/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 23/8/2022
 */

// function addBrackets(placeholder){
// 	return `{{${placeholder}}`
// }
// export const MessagePlaceholdersEnum = Object.freeze({
// 	CLIENT_FIRST_NAME: addBrackets(MessagePlaceholderNamesEnum.CLIENT_FIRST_NAME),
// 	CLIENT_FULL_NAME: addBrackets(MessagePlaceholderNamesEnum.CLIENT_LAST_NAME),
// 	CLIENT_LAST_NAME: addBrackets(MessagePlaceholderNamesEnum.CLIENT_FULL_NAME),
//
// 	INVITEE_FIRST_NAME: addBrackets(MessagePlaceholderNamesEnum.INVITEE_FIRST_NAME),
// 	INVITEE_LAST_NAME: addBrackets(MessagePlaceholderNamesEnum.INVITEE_LAST_NAME),
// 	INVITEE_FULL_NAME: addBrackets(MessagePlaceholderNamesEnum.INVITEE_FULL_NAME),
//
// 	COACH_FIRST_NAME: addBrackets(MessagePlaceholderNamesEnum.COACH_FIRST_NAME),
// 	COACH_LAST_NAME: addBrackets(MessagePlaceholderNamesEnum.COACH_LAST_NAME),
// 	COACH_FULL_NAME: addBrackets(MessagePlaceholderNamesEnum.COACH_FULL_NAME),
//
// 	SESSION_DATE: addBrackets(MessagePlaceholderNamesEnum.SESSION_DATE),
// 	SESSION_TIME: addBrackets(MessagePlaceholderNamesEnum.SESSION_TIME),
// 	SESSION_NAME: addBrackets(MessagePlaceholderNamesEnum.SESSION_NAME),
// 	SESSION_LOCATION: addBrackets(MessagePlaceholderNamesEnum.SESSION_DATE),
//
// 	ATTACHED_FILES: "{{attached_files}}",
// 	LEGAL_DOCS: "{{legal_docs}}",
// })
// export const MessagePlaceholderNamesEnum = Object.freeze({
// 	CLIENT_FIRST_NAME: "client_first_name",
// 	CLIENT_LAST_NAME: "client_last_name",
// 	CLIENT_FULL_NAME: "client_full_name",
//
// 	INVITEE_FIRST_NAME: "invitee_first_name",
// 	INVITEE_LAST_NAME: "invitee_last_name",
// 	INVITEE_FULL_NAME: "invitee_full_name",
//
// 	COACH_FIRST_NAME: "coach_first_name",
// 	COACH_LAST_NAME: "coach_last_name",
// 	COACH_FULL_NAME: "coach_full_name",
//
// 	SESSION_DATE: "session_date",
// 	SESSION_TIME: "session_time",
// 	SESSION_NAME: "session_name",
// 	SESSION_LOCATION: "session_location",
//
// 	ATTACHED_FILES: "attached_files",
// 	LEGAL_DOCS: "legal_docs",
// })







export function noBrackets(placeholder){
	return placeholder.substring(2, placeholder.length - 2)
}

export const MessagePlaceholdersEnum = Object.freeze({
	MEMBER_FIRST_NAME: "{{member_first_name}}",
	MEMBER_LAST_NAME: "{{member_last_name}}",

	CLIENT_FIRST_NAME: "{{client_first_name}}",
	CLIENT_LAST_NAME: "{{client_last_name}}",
	CLIENT_FULL_NAME: "{{client_full_name}}",

	INVITEE_FIRST_NAME: "{{invitee_first_name}}",
	INVITEE_LAST_NAME: "{{invitee_last_name}}",
	INVITEE_FULL_NAME: "{{invitee_full_name}}",

	COACH_FIRST_NAME: "{{coach_first_name}}",
	COACH_LAST_NAME: "{{coach_last_name}}",
	COACH_FULL_NAME: "{{coach_full_name}}",

	SESSION_DATE: "{{session_date}}",
	SESSION_TIME: "{{session_time}}",
	SESSION_NAME: "{{session_name}}",
	SESSION_LOCATION: "{{session_location}}",

	ATTACHED_FILES: "{{attached_files}}",
	LEGAL_DOCS: "{{legal_docs}}",
})


export const INVITEE_FIRST_NAME_TAG 	= {label: "Invitee first name", value: MessagePlaceholdersEnum.INVITEE_FIRST_NAME}
export const INVITEE_LAST_NAME_TAG 		= {label: "Invitee last name", value: MessagePlaceholdersEnum.INVITEE_LAST_NAME}
export const INVITEE_FULL_NAME_TAG 		= {label: "Invitee last name", value: MessagePlaceholdersEnum.INVITEE_FULL_NAME}
export const SESSION_START_DATE_TAG 	= {label: "Session start date", value: MessagePlaceholdersEnum.SESSION_DATE}
export const SESSION_START_TIME_TAG 	= {label: "Session start time", value: MessagePlaceholdersEnum.SESSION_TIME}
export const SESSION_NAME_TAG		 	= {label: "Session name", value: MessagePlaceholdersEnum.SESSION_NAME}
export const SESSION_LOCATION_TAG		= {label: "Session location", value: MessagePlaceholdersEnum.SESSION_LOCATION}
export const COACH_FIRST_NAME_TAG		= {label: "Coach first name", value: MessagePlaceholdersEnum.COACH_FIRST_NAME}
export const COACH_LAST_NAME_TAG		= {label: "Coach last name", value: MessagePlaceholdersEnum.COACH_LAST_NAME}
export const CLIENT_FIRST_NAME_TAG 		= {label: "Client first name", value: MessagePlaceholdersEnum.CLIENT_FIRST_NAME}
export const CLIENT_LAST_NAME_TAG 		= {label: "Client last name", value: MessagePlaceholdersEnum.CLIENT_LAST_NAME}
export const ATTACHED_FILES_TAG 		= {label: "Attached files", value: MessagePlaceholdersEnum.ATTACHED_FILES}
export const LEGAL_DOCS_TAG 			= {label: "Legal docs", value: MessagePlaceholdersEnum.LEGAL_DOCS}


export const tagsAll = [
	INVITEE_FIRST_NAME_TAG,
	INVITEE_LAST_NAME_TAG,
	INVITEE_FULL_NAME_TAG,
	SESSION_START_DATE_TAG,
	SESSION_START_TIME_TAG,
	SESSION_NAME_TAG,
	SESSION_LOCATION_TAG,
	COACH_FIRST_NAME_TAG,
	COACH_LAST_NAME_TAG,
	ATTACHED_FILES_TAG,
	LEGAL_DOCS_TAG,
	CLIENT_FIRST_NAME_TAG,
	CLIENT_LAST_NAME_TAG,
]



export const templateComposerCommonData = [
	INVITEE_FIRST_NAME_TAG,
	INVITEE_LAST_NAME_TAG,
	SESSION_START_DATE_TAG,
	SESSION_START_TIME_TAG,
	SESSION_NAME_TAG,
	SESSION_LOCATION_TAG,
	COACH_FIRST_NAME_TAG,
	COACH_LAST_NAME_TAG,
]
export const templateComposerBodyData = [
	...templateComposerCommonData,
	ATTACHED_FILES_TAG,
	LEGAL_DOCS_TAG
]


export const welcomeEmailSubjectData = [
	CLIENT_FIRST_NAME_TAG,
	CLIENT_LAST_NAME_TAG,
	COACH_FIRST_NAME_TAG,
	COACH_LAST_NAME_TAG,
]


export const welcomeEmailBodyData = [
	...welcomeEmailSubjectData,
	ATTACHED_FILES_TAG,
	LEGAL_DOCS_TAG,
]

export function splitFullName(fullName){
	let [firstName, ...lastNameSplit] = (fullName || "").split( " ")
	let lastName = lastNameSplit.length ? lastNameSplit.join(" ") : ""
	return {fullName, firstName, lastName}

}
export function applyClientName(fullName, data){
	let nameData = splitFullName(fullName)
	data[noBrackets(MessagePlaceholdersEnum.CLIENT_FULL_NAME)] = nameData.fullName
	data[noBrackets(MessagePlaceholdersEnum.CLIENT_FIRST_NAME)] = nameData.firstName
	data[noBrackets(MessagePlaceholdersEnum.CLIENT_LAST_NAME)] = nameData.lastName

	data[noBrackets(MessagePlaceholdersEnum.INVITEE_FULL_NAME)] = nameData.fullName
	data[noBrackets(MessagePlaceholdersEnum.INVITEE_FIRST_NAME)] = nameData.firstName
	data[noBrackets(MessagePlaceholdersEnum.INVITEE_LAST_NAME)] = nameData.lastName
	return data
}

export function applyCoachName(fullName, data){
	let nameData = splitFullName(fullName)
	data[noBrackets(MessagePlaceholdersEnum.COACH_FULL_NAME)] = nameData.fullName
	data[noBrackets(MessagePlaceholdersEnum.COACH_FIRST_NAME)] = nameData.firstName
	data[noBrackets(MessagePlaceholdersEnum.COACH_LAST_NAME)] = nameData.lastName
	return data
}
